import React, { Component } from "react";
import ReactGA from "react-ga";
import BannerImg from "../../assets/images/banner/java-development.png";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

class JavaDevelopment extends Component {
  state = {};
  render() {
    ReactGA.initialize("UA-5235714-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>Java Development & Enterprise Application Engineering Heritage | Avani Cimcon</title>
          <meta
            name="keywords"
            content="java development services, java developers, java application development, outsourcing java development, offshore java development, hire java developers, customized java development solutions, Java solutions and services, java solutions architects, java solutions architecture, java technologies, java applications, java web development framework, java development frameworks, java api, java software application, java web application, J2EE application developers, enterprise application engineering, legacy modernization, platform migration, enterprise integration"
          />
          <meta
            name="description"
            content="Java is part of Avani Cimcon's enterprise application engineering heritage. The experience supports modernization, migration, integration, and long-term maintenance of complex systems."
          />
          <link rel="canonical" href="https://www.avanicimcon.com/java-development" />
        </Helmet>

        <div className="page-banner d-flex align-items-center justify-content-center text-white">
          <div className="page-title container position-relative">
            <h1 className="font-weight-bold text-uppercase">Java Development</h1>
            <h5>Enterprise application engineering heritage</h5>
          </div>
          <div className="page-banner-img" style={{ backgroundImage: `url("${BannerImg}")` }}></div>
          <div className="page-banner-overlay"></div>
        </div>

        <div className="inner-page mt-5 mb-5 ">
          <div className="container">
            <div className="text-justify">
              <p className="font-weight-bold text-primary">
                Java development is part of our enterprise architecture depth. It reflects the
                engineering discipline used to build robust frameworks, modernize applications, and
                maintain complex systems over time.
              </p>
              <p>
                Avani Cimcon Technologies (ACT) is one of the pioneers in developing applications in
                Java technologies. Our core strategy for Java Development is to develop a robust and
                a versatile generic framework that allows us to build business centric applications.
                In the development of this framework we have utilized our vast and varied experience
                gained over a number of years by developing software and products for different
                customers from all over the world. The other key strategy has been to invest in
                training and gaining expertise on industry standard development platforms available
                in Java such as Weblogic and IBM Websphere.
              </p>

              <p>
                We have invested time in architecting, designing, developing and testing the Java
                Framework. An experienced and a dedicated team have enabled us to create this
                framework in a short period of time. ACT Java Framework is robust and flexible and
                addresses specific types of work that an organization undertakes.
              </p>

              <p>
                For maintenance, ACT’s resource pool has experienced senior programmers, who
                maintain and enhance the Java Framework, always in a secured environment.
              </p>

              <h5 className="text-primary mt-4 mb-3">
                The advantages of this Framework are listed below:
              </h5>

              <ul>
                <li className="mb-2">Re-usability of Code</li>
                <li className="mb-2">Rapid Development</li>
                <li className="mb-2">Designers and Developers can work simultaneously</li>
                <li className="mb-2">Changes in the Layout</li>
                <li className="mb-2">Changes in Business Logic</li>
                <li className="mb-2">Recursive Processing</li>
                <li className="mb-2">Dynamic Content</li>
                <li>Web Services</li>
              </ul>

              <h5 className="text-primary mt-4 mb-3">Our Skillset</h5>

              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td className="bg-light font-weight-bold">Core APIs</td>
                    <td>
                      Servlets, Java Server Pages (JSP), Tag libraries, Struts, J2ME, EJB,
                      Hibernate, Java Transactions API, Java Mail API.
                    </td>
                  </tr>

                  <tr>
                    <td className="bg-light font-weight-bold">Java XML</td>
                    <td>DOM & SAX, Xerces</td>
                  </tr>

                  <tr>
                    <td className="bg-light font-weight-bold">Java Performance</td>
                    <td>
                      JVM tuning, Memory and Disk Caching, Java I/O Performance, JUnit Testing
                    </td>
                  </tr>

                  <tr>
                    <td className="bg-light font-weight-bold">Web Services</td>
                    <td>SOAP, RPC, WSDL, UDDI</td>
                  </tr>
                </tbody>
              </table>

              <p>
                With excellent technical resources and years of experience, ACT is in a position of
                proving itself as one of the best choices for Java solutions and services in
                enterprise modernization, integration, and software evolution.
              </p>

              <div className="mt-4 p-4 bg-light border rounded">
                <h5 className="text-primary mb-3">Why Java experience still accelerates modernization</h5>
                <ul className="mb-0">
                  <li className="mb-2">
                    <Link to="/it-consulting-services">Use Java platform depth to modernize enterprise applications safely</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/project-management">Support complex migrations with disciplined delivery</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Discuss Java modernization, migration, or integration support</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default JavaDevelopment;
